import { render } from "./LikeView.vue?vue&type=template&id=a32ef16c&scoped=true"
import script from "./LikeView.vue?vue&type=script&lang=js"
export * from "./LikeView.vue?vue&type=script&lang=js"

import "./LikeView.vue?vue&type=style&index=0&id=a32ef16c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32ef16c"]])

export default __exports__